import React, { useEffect, useRef, useState } from "react";
import "./Your_Location_Info_Modal.css";
import { InputGroup, Modal, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";
import Back_arrow_holder from "../../Back_arrow_holder/Back_arrow_holder";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import { getCurrentLocation, setCurrentLocation } from "../../../../features/location/locationSlice";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import axios from "axios";

function Your_Location_Info_Modal(props) {
  const dispatch = useDispatch();
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

  const [searchQuery, setSearchQuery] = useState("");
  const [address, setAddress] = useState(null);
  const mapRef = useRef(null);

  // Initialize Google Map
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
    script.async = true;
    script.defer = true;
    window.initMap = initMap;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [props.show]);

  const initMap = () => {
    const lastCoords = Cookies.get("last_coords");
    const defaultCoords = { lat: 18.51222785666292, lng: 73.87566681741158 };
    const coords = lastCoords ? JSON.parse(lastCoords) : defaultCoords;

    const map = new window.google.maps.Map(mapRef.current, {
      center: coords,
      zoom: 14,
    });
    mapRef.current.mapInstance = map;

    let marker = null;
    if (lastCoords) {
      marker = new window.google.maps.Marker({
        position: coords,
        map: map,
        title: "Last Selected Location",
      });
      mapRef.current.marker = marker;
    }

    map.addListener("click", (event) => {
      const clickedLocation = event.latLng;
      const lat = clickedLocation.lat();
      const lng = clickedLocation.lng();

      if (!marker) {
        marker = new window.google.maps.Marker({
          position: clickedLocation,
          map: map,
        });
        mapRef.current.marker = marker;
      } else {
        marker.setPosition(clickedLocation);
      }

      reverseGeocode(lat, lng);
      Cookies.set("last_coords", JSON.stringify({ lat, lng }));
    });
  };

  // Reverse Geocode to get address
  const reverseGeocode = async (lat, lng) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
      );

      if (response.data.status === "OK") {
        const addressDetails = response.data.results[0];
        setAddress(addressDetails);
        Cookies.set("current_location_grocido", JSON.stringify(addressDetails));
        dispatch(setCurrentLocation(addressDetails));
      }
    } catch (error) {
      console.error("Geocoding API error:", error);
    }
  };

  // Search location and move marker
  const handleSearchLocation = async () => {
    if (!searchQuery) return;

    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(searchQuery)}&key=${apiKey}`
      );

      if (response.data.status === "OK") {
        const location = response.data.results[0];
        const { lat, lng } = location.geometry.location;

        const map = mapRef.current.mapInstance;
        if (map) {
          map.setCenter({ lat, lng });

          if (!mapRef.current.marker) {
            mapRef.current.marker = new window.google.maps.Marker({
              position: { lat, lng },
              map: map,
            });
          } else {
            mapRef.current.marker.setPosition({ lat, lng });
          }
        }

        setAddress(location);
        Cookies.set("current_location_grocido", JSON.stringify(location));
        dispatch(setCurrentLocation(location));
      } else {
        console.error("No location found");
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  const onEnableAutoFetch = async () => {
    await dispatch(getCurrentLocation());
    props.onHide();
  };

  return (
    <section className="Confirm_Location_modal modal-holder">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Confirm_Location_modal Your_Location_Info_Modal modal-holder"
      >
        <Modal.Header>
          <Back_arrow_holder onClick={props.onHide} />
          <Modal.Title>{props?.modalTitle}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="search-field-holder">
            <div className="search-field p-2">
              <InputGroup className="mb-3">
                <Form.Control
                  placeholder="Search Locations"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <InputGroup.Text onClick={handleSearchLocation}>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <InputGroup.Text onClick={handleClearSearch} className="clear-icon">
                  <FontAwesomeIcon icon={faXmark} />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>

          <div
            id="map"
            ref={mapRef}
            style={{ width: "100%", height: "500px" }}
          ></div>
        </Modal.Body>

        <div className="footer-btn-holder">
          <div className="text-holder">
            <p>{address?.formatted_address || props?.current_location?.formatted_address}</p>
          </div>

          <div
            className="text-center btn_holder"
            onClick={() => {
              props.onHide();
            }}
          >
            <Green_Btn btn_name={props?.btnText} />
          </div>
        </div>
      </Modal>
    </section>
  );
}

export default Your_Location_Info_Modal;
